<div
  class="screen-recorder-heatmap recorder-ai-chat"
  [ngClass]="{
    'dark-theme': darkMode,
    'comparison-mode': selectedChatObj?.comparison && selectedChatObj?.summary,
  }"
>
  <div class="screen-recorder-heatmap_nav">
    <ng-container *ngIf="!firstLoader">
      <div class="screen-recorder-heatmap_nav-header-top">
        <div class="screen-recorder-heatmap_nav-header">
          <h1>{{ "phrases.ai_analysis" | translate }}</h1>
        </div>
        <div
          class="screen-recorder-heatmap_nav-content"
          style="width: 100%; padding: 0"
        >
          <!-- <button
            mat-mini-fab
            style="color: #3a405b"
            (click)="triggerSidenav()"
            id="side-trigger"
          >
            <mat-icon>menu</mat-icon>
          </button> -->

          <div class="recorder_player-theme-mode" style="margin: 0 0 0 auto">
            <p>{{ "phrases.dark_mode" | translate }}</p>
            <mat-slide-toggle
              class="example-margin"
              [checked]="darkMode"
              (change)="switchThemeMode($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
      </div>
      <div
        class="screen-recorder-heatmap_nav-header-bottom"
        *ngIf="
          params_constructed?.filters?.length > 0 &&
          constructedChatContent?.length > 0
        "
      >
        <div class="chat-content-message-placeholder-content-filters">
          <ng-container
            *ngIf="!selectedChatObj?.comparison && commonFilters?.length == 0"
          >
            <p style="white-space: nowrap">
              {{ "phrases.active_filters" | translate }}:
            </p>
            <div
              style="
                display: flex;
                gap: 10px;
                overflow-x: auto;
                overflow-y: hidden;
              "
            >
              <div *ngIf="params_constructed.userId">
                <div class="competitor-holder custom-matMenu-holder">
                  <button
                    class="custom-button btn_withoutIcon custom-filters full-border"
                    mat-raised-button
                    type="button"
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        width: 100% !important;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          line-height: 17px;
                          color: #586171;
                          flex-grow: 1;
                          margin: -10px 0 -10px -10px;
                          padding: 10px 0 10px 10px;
                        "
                      >
                        <span class="spanLabel custom-filters-name">
                          {{ "phrases.user_id" | translate }} |
                        </span>
                        <span class="btn-country-name btn-country-name-color">
                          {{ params_constructed.userId }}
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
              <div>
                <div class="competitor-holder custom-matMenu-holder">
                  <button
                    class="custom-button btn_withoutIcon custom-filters full-border"
                    mat-raised-button
                    type="button"
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        width: 100% !important;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          line-height: 17px;
                          color: #586171;
                          flex-grow: 1;
                          margin: -10px 0 -10px -10px;
                          padding: 10px 0 10px 10px;
                        "
                      >
                        <span class="spanLabel custom-filters-name">
                          {{ "phrases.start_date" | translate }} |
                        </span>
                        <span class="btn-country-name btn-country-name-color">
                          {{ params_constructed.startDate }}
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
              <div>
                <div class="competitor-holder custom-matMenu-holder">
                  <button
                    class="custom-button btn_withoutIcon custom-filters full-border"
                    mat-raised-button
                    type="button"
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        width: 100% !important;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          line-height: 17px;
                          color: #586171;
                          flex-grow: 1;
                          margin: -10px 0 -10px -10px;
                          padding: 10px 0 10px 10px;
                        "
                      >
                        <span class="spanLabel custom-filters-name">
                          {{ "phrases.end_date" | translate }} |
                        </span>
                        <span class="btn-country-name btn-country-name-color">
                          {{ params_constructed.endDate }}
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
              <div *ngFor="let filter of params_constructed?.filters">
                <div class="competitor-holder custom-matMenu-holder">
                  <button
                    class="custom-button btn_withoutIcon custom-filters full-border"
                    mat-raised-button
                    type="button"
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        width: 100% !important;
                      "
                    >
                      <!-- Click area for filter editing -->
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          line-height: 17px;
                          color: #586171;
                          flex-grow: 1;
                          margin: -10px 0 -10px -10px;
                          padding: 10px 0 10px 10px;
                        "
                      >
                        <span
                          class="spanLabel custom-filters-name"
                          *ngIf="filter.label !== ''"
                          >{{ returnTranslated(filter.label) }} |
                        </span>
                        <span
                          class="btn-country-name btn-country-name-color"
                          [matTooltip]="
                            filter.value.length > 50 ? filter.value : ''
                          "
                          matTooltipPosition="above"
                        >
                          {{ returnTranslated(truncateText(filter.value)) }}
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container
            *ngIf="selectedChatObj?.comparison && commonFilters?.length > 0"
          >
            <p style="white-space: nowrap">
              {{ "phrases.common_filters" | translate }}:
            </p>
            <div
              style="
                display: flex;
                gap: 10px;
                overflow-x: auto;
                overflow-y: hidden;
              "
            >
              <div *ngFor="let filter of commonFilters">
                <div class="competitor-holder custom-matMenu-holder">
                  <button
                    class="custom-button btn_withoutIcon custom-filters full-border"
                    mat-raised-button
                    type="button"
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        width: 100% !important;
                      "
                    >
                      <!-- Click area for filter editing -->
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          line-height: 17px;
                          color: #586171;
                          flex-grow: 1;
                          margin: -10px 0 -10px -10px;
                          padding: 10px 0 10px 10px;
                        "
                      >
                        <span
                          class="spanLabel custom-filters-name"
                          *ngIf="filter.label !== ''"
                          >{{ returnTranslated(filter.label) }} |
                        </span>
                        <span
                          class="btn-country-name btn-country-name-color"
                          [matTooltip]="
                            filter.value.length > 50 ? filter.value : ''
                          "
                          matTooltipPosition="above"
                        >
                          {{ returnTranslated(truncateText(filter.value)) }}
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="firstLoader">
      <div style="width: calc(100% - 40px); padding: 0 20px">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            outline: 'none',
            height: '30px',
            'background-color': '#37474f1a',
            'margin-bottom': '-5px',
          }"
        ></ngx-skeleton-loader>
      </div>
    </ng-container>
  </div>
  <div
    class="screen-recorder-heatmap_left"
    [ngClass]="{ active: sidenavToogle }"
  >
    <div class="screen-recorder-heatmap_left-header">
      <div class="recorder_player_nav_goBack" (click)="goBackToDashboard()">
        <svg
          width="18"
          height="16"
          viewBox="0 0 18 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.57895 1L2 7.73684M2 7.73684L8.73684 14.4737M2 7.73684L18 7.73684"
            stroke="black"
            stroke-width="1.68421"
          />
        </svg>
        <p>{{ "phrases.return_to_dashboard" | translate }}</p>
      </div>
      <button
        mat-mini-fab
        style="color: #3a405b"
        (click)="triggerSidenav()"
        id="side-trigger"
      >
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="screen-recorder-heatmaps_hr"></div>
    <ng-container *ngIf="!firstLoader">
      <p class="screen-recorder-heatmaps_list-title">
        {{ "phrases.ai_analyses" | translate }}
      </p>
      <div class="screen-recorder-heatmaps_list">
        <div
          class="screen-recorder-heatmaps_list-item"
          *ngFor="let analysis of analysesHistory; let i = index"
          (click)="selectAnalysis(analysis)"
          [ngClass]="{ active: analysis.videoID == this.chatID }"
          (mouseenter)="checkIfTooltipNeedsToBeShown(analysis, i)"
        >
          <p [matTooltip]="analysis.tooltipText" matTooltipPosition="above">
            {{ analysis.title }}
          </p>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="firstLoader">
      <ngx-skeleton-loader
        count="6"
        [theme]="{
          outline: 'none',
          height: '40px',
          'background-color': '#37474f1a',
          'margin-bottom': '16px',
        }"
      ></ngx-skeleton-loader>
    </ng-container>
  </div>
  <div
    class="screen-recorder-heatmap_left-background"
    (click)="triggerSidenav()"
  ></div>
  <div
    class="screen-recorder-heatmap_comparison"
    *ngIf="selectedChatObj?.comparison && selectedChatObj?.summary"
  >
    <div class="screen-recorder-heatmap_comparison-groups">
      <div
        class="comparison-group"
        *ngIf="comparisonSummaries?.groupA?.length > 0"
      >
        <div class="comparison-group-header">
          {{ "phrases.group_a" | translate }}
        </div>
        <div
          class="comparison-group-content"
          [ngClass]="{
            'has-filters': comparisonSummaries?.groupAFilters?.length > 0,
          }"
        >
          <div
            class="comparison-group-content-group"
            *ngIf="comparisonSummaries?.groupAFilters == 0"
          >
            <div
              class="comparison-group-content-item"
              *ngFor="let item of comparisonSummaries?.groupA"
            >
              <div class="comparison-group-content-item-key">{{ item[0] }}</div>
              <div class="comparison-group-content-item-value">
                {{ item[1] }}
              </div>
            </div>
          </div>
          <div
            class="comparison-group-content-group"
            *ngIf="comparisonSummaries?.groupAFilters?.length > 0"
          >
            <div class="comparison-group-content-group-filters pills-container">
              <div *ngFor="let filter of comparisonSummaries?.groupAFilters">
                <div class="competitor-holder custom-matMenu-holder">
                  <button
                    class="custom-button btn_withoutIcon custom-filters full-border"
                    mat-raised-button
                    type="button"
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        width: 100% !important;
                      "
                    >
                      <!-- Click area for filter editing -->
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          line-height: 17px;
                          color: #586171;
                          flex-grow: 1;
                          margin: -10px 0 -10px -10px;
                          padding: 10px 0 10px 10px;
                        "
                      >
                        <span
                          class="spanLabel custom-filters-name"
                          *ngIf="filter.label !== ''"
                          >{{ returnTranslated(filter.label) }} |
                        </span>
                        <span
                          class="btn-country-name btn-country-name-color"
                          [matTooltip]="
                            filter.value.length > 50 ? filter.value : ''
                          "
                          matTooltipPosition="above"
                        >
                          {{ returnTranslated(truncateText(filter.value)) }}
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="comparison-group-vs">
        <span> vs </span>
      </div>
      <div
        class="comparison-group"
        *ngIf="comparisonSummaries?.groupB?.length > 0"
      >
        <div class="comparison-group-header">
          {{ "phrases.group_b" | translate }}
        </div>
        <div
          class="comparison-group-content"
          [ngClass]="{
            'has-filters': comparisonSummaries?.groupBFilters?.length > 0,
          }"
        >
          <div
            class="comparison-group-content-group"
            *ngIf="comparisonSummaries?.groupBFilters == 0"
          >
            <div
              class="comparison-group-content-item"
              *ngFor="let item of comparisonSummaries?.groupB"
            >
              <div class="comparison-group-content-item-key">{{ item[0] }}</div>
              <div class="comparison-group-content-item-value">
                {{ item[1] }}
              </div>
            </div>
          </div>
          <div
            class="comparison-group-content-group"
            *ngIf="comparisonSummaries?.groupBFilters?.length > 0"
          >
            <div class="comparison-group-content-group-filters pills-container">
              <div *ngFor="let filter of comparisonSummaries?.groupBFilters">
                <div class="competitor-holder custom-matMenu-holder">
                  <button
                    class="custom-button btn_withoutIcon custom-filters full-border"
                    mat-raised-button
                    type="button"
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        width: 100% !important;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          line-height: 17px;
                          color: #586171;
                          flex-grow: 1;
                          margin: -10px 0 -10px -10px;
                          padding: 10px 0 10px 10px;
                        "
                      >
                        <span
                          class="spanLabel custom-filters-name"
                          *ngIf="filter.label !== ''"
                          >{{ returnTranslated(filter.label) }} |
                        </span>
                        <span
                          class="btn-country-name btn-country-name-color"
                          [matTooltip]="
                            filter.value.length > 50 ? filter.value : ''
                          "
                          matTooltipPosition="above"
                        >
                          {{ returnTranslated(truncateText(filter.value)) }}
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="screen-recorder-heatmap_main">
    <div class="heatmap_container">
      <ng-container *ngIf="!firstLoader">
        <div
          *ngIf="
            showChatInput ||
            !showTemplateView ||
            constructedChatContent?.length > 0
          "
          class="chat-container"
          [class.drag-over]="dragOver"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave()"
          (drop)="onDrop($event)"
        >
          <div class="chat-messages">
            <div
              *ngIf="constructedChatContent?.length === 0 && !showTemplateView"
              class="chat-content-message-placeholder"
            >
              <div class="chat-content-message-placeholder-content">
                <p *ngIf="!showPlaceholderWithFilters">
                  {{ "phrases.start_typing_to_ask_anything" | translate }}
                </p>
                <ng-container
                  *ngIf="showPlaceholderWithFilters && !isChatLoading"
                >
                  <p>
                    {{
                      sendMessageLoading
                        ? ("phrases.analyzing_recordings_from_d1_to_d2"
                          | translate
                            : {
                                date1: params_constructed.startDate,
                                date2: params_constructed.endDate,
                              })
                        : ("phrases.ready_to_analyze_recordings_from_d1_to_d2"
                          | translate
                            : {
                                date1: params_constructed.startDate,
                                date2: params_constructed.endDate,
                              })
                    }}
                  </p>
                  <div
                    class="chat-content-message-placeholder-content-filters"
                    *ngIf="params_constructed?.filters?.length > 0"
                  >
                    <p>{{ "words.filters" | translate }}:</p>
                    <div *ngFor="let filter of params_constructed?.filters">
                      <div class="competitor-holder custom-matMenu-holder">
                        <button
                          class="custom-button btn_withoutIcon custom-filters full-border"
                          mat-raised-button
                          type="button"
                        >
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              gap: 5px;
                              width: 100% !important;
                            "
                          >
                            <!-- Click area for filter editing -->
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                line-height: 17px;
                                color: #586171;
                                flex-grow: 1;
                                margin: -10px 0 -10px -10px;
                                padding: 10px 0 10px 10px;
                              "
                            >
                              <span class="spanLabel custom-filters-name"
                                >{{ returnTranslated(filter.label) }} |
                              </span>
                              <span
                                class="btn-country-name btn-country-name-color"
                                [matTooltip]="
                                  filter.value.length > 50 ? filter.value : ''
                                "
                                matTooltipPosition="above"
                              >
                                {{
                                  returnTranslated(truncateText(filter.value))
                                }}
                              </span>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    class="multi_lines_loading_text_container min-height-100 background-transparent"
                    *ngIf="sendMessageLoading"
                  >
                    <div class="multi_lines_loading_text">
                      <p
                        *ngFor="let message of loaderMessages; let i = index"
                        [ngClass]="{
                          active: i == messageLoaderLineIndex,
                          before: i < messageLoaderLineIndex,
                          after: i > messageLoaderLineIndex,
                        }"
                      >
                        {{ returnTranslated(message) }}
                      </p>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div
              *ngIf="showTemplateView && showChatInput"
              class="chat-content-message chat-content-message-template"
              [innerHTML]="template"
            ></div>
            <div
              *ngFor="let message of constructedChatContent"
              class="chat-content-message"
              [ngClass]="{ 'chat-content-message-user': message.isUser }"
            >
              <div
                class="chat-content-message-images"
                *ngIf="message.images?.length > 0"
              >
                <div
                  class="chat-content-message-images-container"
                  *ngFor="let image of message.images"
                >
                  <img
                    [src]="image?.url"
                    alt=""
                    draggable="false"
                    (click)="showScreenshot(image?.url)"
                  />
                </div>
              </div>
              <div
                class="chat-content-message-content"
                [innerHTML]="message.message"
              ></div>
            </div>
            <div
              class="multi_lines_loading_text_container min-height-100 background-transparent"
              *ngIf="sendMessageLoading && constructedChatContent?.length > 0"
            >
              <div class="multi_lines_loading_text text-align-left">
                <p
                  *ngFor="let message of loaderMessages; let i = index"
                  [ngClass]="{
                    active: i == messageLoaderLineIndex,
                    before: i < messageLoaderLineIndex,
                    after: i > messageLoaderLineIndex,
                  }"
                >
                  {{ message }}
                </p>
              </div>
            </div>
          </div>
          <div class="chat-input-container" *ngIf="showChatInput">
            <div class="chat-input-container-inner">
              <div class="image-container_main" *ngIf="files.length">
                <div
                  class="image-container"
                  *ngFor="let f of files; let i = index"
                >
                  <img [src]="f.previewUrl" [alt]="f.name || 'image preview'" />
                  <button
                    type="button"
                    class="remove"
                    (click)="removeAt(i)"
                    aria-label="Remove"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>

              <div class="chat-input">
                <textarea
                  [(ngModel)]="chatInput"
                  name="chat-input"
                  id="chat-input"
                  placeholder="{{ 'phrases.ask_anything' | translate }}"
                  (keydown.enter)="onEnter($event)"
                  #chatTextarea
                  (input)="adjustTextareaHeight(chatTextarea)"
                  [disabled]="sendMessageLoading || disableTextareaInput"
                  autofocus
                ></textarea>
                <button
                  *ngIf="chatInput && chatInput.length > 0 && !streamingStarted"
                  (click)="sendMessage()"
                >
                  <mat-icon>send</mat-icon>
                </button>
                <button *ngIf="streamingStarted" (click)="cancelCurrentAI()">
                  <span class="chat-stop-icon"></span>
                </button>
                <button
                  type="button"
                  class="add-image-btn"
                  (click)="fileInput.click()"
                  [disabled]="streamingStarted"
                >
                  <mat-icon>add_photo_alternate</mat-icon>
                </button>
                <input
                  #fileInput
                  type="file"
                  accept="image/*"
                  multiple
                  (change)="onPickFiles($event)"
                  hidden
                />
              </div>

              <div class="drag-image-placeholder">
                <mat-icon>add_photo_alternate</mat-icon>
                <span class="drag-image-placeholder_title">
                  {{ "phrases.drag__drop_images_here" | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="showTemplateView && !showChatInput"
          class="chat-container zebrabox-container"
          [innerHTML]="template"
        ></div>
      </ng-container>
      <ng-container *ngIf="firstLoader">
        <div>
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              outline: 'none',
              height: '360px',
              'background-color': '#37474f1a',
              'margin-bottom': '-5px',
            }"
          ></ngx-skeleton-loader>
        </div>
      </ng-container>

      <div class="loading-data-overlay chat_spinner" *ngIf="isChatLoading">
        <div class="chat_spinner_content">
          <mat-spinner></mat-spinner>
        </div>
      </div>
      <div class="heatmap-side_container">
        <ng-container *ngIf="!firstLoader">
          <!-- <div class="heatmap-side-content">
          <div class="heatmap-side-content_header">
            <h3>Map types</h3>
            <span
              class="heatmap-side-content_header-icon"
              (click)="toogleOpenClose($event)"
            >
              <svg
                width="17"
                height="11"
                viewBox="0 0 17 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 1.5L8.5 9L1 1.5"
                  stroke="black"
                  stroke-width="1.5"
                />
              </svg>
            </span>
          </div>
          <div class="heatmap-side-content_container">test test</div>
        </div> -->
        </ng-container>
        <ng-container *ngIf="firstLoader">
          <div>
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                outline: 'none',
                height: '360px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
